module.exports = __webpack_public_path__ + "static/img/4-4.3341fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-4.png
// module id = RVd0
// module chunks = 12